import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e4411ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "w-full bg-white" }
const _hoisted_3 = ["name"]
const _hoisted_4 = { class: "flex w-full" }
const _hoisted_5 = {
  key: 0,
  class: "px-2"
}

import { ref, computed, onMounted } from "vue"
import CaretIcon from "@/components/icons/CaretIcon.vue"
import { NavigationChildItem } from "@/shared/models/navigation"
import { useRoute } from "vue-router"

interface Props {
    childrenItems: NavigationChildItem[]
    name?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsDisclosureForNavigation',
  props: {
    childrenItems: {},
    name: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const route = useRoute()

const isOpen = ref(false)
const chevronIconClass = computed(() =>
    isOpen.value
        ? "rotate-90 transform stroke-primary-color-500 fill-primary-color-500"
        : "stroke-gray-300 fill-gray-300"
)

const chevronIconFillClass = computed(() => (isOpen.value ? "fill-primary-color-500" : "fill-gray-300"))

function toggleDisclosure() {
    isOpen.value = !isOpen.value
}

function checkIfDisclosureOpened() {
    if (props.childrenItems.some(({ path }) => path === route.path)) {
        toggleDisclosure()
    }
}

function closeDisclosure() {
    isOpen.value = false
}

onMounted(() => {
    checkIfDisclosureOpened()
})

__expose({
    closeDisclosure,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex w-full items-center justify-between px-3 py-2 bg-white text-left text-base font-medium cursor-pointer hover:bg-gray-50 rounded-lg",
        name: props.name,
        onClick: toggleDisclosure
      }, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header", {
            isOpen: isOpen.value,
            close: closeDisclosure
          })
        ]),
        _createVNode(CaretIcon, {
          class: _normalizeClass(["h-5 w-5 select-none cursor-pointer", chevronIconClass.value]),
          fill: chevronIconFillClass.value
        }, null, 8, ["fill", "class"])
      ], 8, _hoisted_3),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "content", {
              isOpen: isOpen.value,
              close: closeDisclosure
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})